import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("strong", null, "Massetildeling af roller til profiler vha. csv-fil", -1)
const _hoisted_2 = { class: "bg-white rounded p-4 mb-4" }
const _hoisted_3 = { class: "mb-3" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Upload CSV-fil ")
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-md-6" }
const _hoisted_7 = { class: "mb-3" }
const _hoisted_8 = /*#__PURE__*/_createVNode("label", {
  for: "csvFile",
  class: "form-label"
}, "Vælg CSV-fil med rolletildelinger", -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "form-text" }, " CSV filen skal indeholde kolonnerne: OrgCVR, Email, RoleID ", -1)
const _hoisted_10 = {
  key: 0,
  class: "alert alert-info"
}
const _hoisted_11 = /*#__PURE__*/_createVNode("strong", null, "Valgt fil:", -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Upload CSV-fil ")
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "col-md-6" }, [
  /*#__PURE__*/_createVNode("div", { class: "card" }, [
    /*#__PURE__*/_createVNode("div", { class: "card-header" }, [
      /*#__PURE__*/_createVNode("h6", { class: "mb-0" }, "CSV-filformat")
    ]),
    /*#__PURE__*/_createVNode("div", { class: "card-body" }, [
      /*#__PURE__*/_createVNode("pre", { class: "mb-0" }, [
        /*#__PURE__*/_createVNode("code", null, "OrgCVR;Email;RoleID\n12345678;user@example.com;SG-Company-Admin\n87654321;user2@example.com;SG-Company-Driver")
      ])
    ])
  ])
], -1)
const _hoisted_14 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_15 = {
  key: 0,
  class: "alert alert-success"
}
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Upload Succesfuld ")
const _hoisted_17 = { class: "mb-0" }
const _hoisted_18 = {
  key: 1,
  class: "alert alert-danger",
  style: {"max-height":"500px","overflow-y":"auto"}
}
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Upload Fejl ")
const _hoisted_20 = { class: "mb-0" }
const _hoisted_21 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { class: "mb-3" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" Udfør rolletildelinger ")
const _hoisted_26 = { class: "row" }
const _hoisted_27 = { class: "col-12" }
const _hoisted_28 = {
  key: 0,
  class: "alert alert-warning d-flex align-items-center mb-3"
}
const _hoisted_29 = /*#__PURE__*/_createVNode("strong", null, "Rolle tildeling kører i øjeblikket...", -1)
const _hoisted_30 = {
  key: 1,
  class: "d-flex gap-3"
}
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" Simulation ")
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" Udfør ")
const _hoisted_33 = {
  key: 2,
  class: "mt-4"
}
const _hoisted_34 = {
  key: 0,
  class: "alert alert-success"
}
const _hoisted_35 = { class: "mb-2" }
const _hoisted_36 = /*#__PURE__*/_createVNode("strong", null, "Total tildelinger:", -1)
const _hoisted_37 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_38 = /*#__PURE__*/_createVNode("strong", null, "Total brugere:", -1)
const _hoisted_39 = { key: 0 }
const _hoisted_40 = { class: "text-muted" }
const _hoisted_41 = {
  key: 1,
  class: "alert alert-danger"
}
const _hoisted_42 = { class: "mb-0" }
const _hoisted_43 = { class: "bg-white rounded p-4 mb-4" }
const _hoisted_44 = { class: "mb-3" }
const _hoisted_45 = /*#__PURE__*/_createTextVNode(" Seneste behandlingshistorik ")
const _hoisted_46 = { class: "row" }
const _hoisted_47 = { class: "col-md-6" }
const _hoisted_48 = { class: "card" }
const _hoisted_49 = { class: "card-header d-flex align-items-center" }
const _hoisted_50 = /*#__PURE__*/_createVNode("h6", { class: "mb-0" }, "Seneste simulation", -1)
const _hoisted_51 = { class: "card-body" }
const _hoisted_52 = {
  key: 0,
  class: "mb-0"
}
const _hoisted_53 = { class: "mb-2" }
const _hoisted_54 = { class: "mb-1" }
const _hoisted_55 = /*#__PURE__*/_createVNode("strong", null, "Tildelinger:", -1)
const _hoisted_56 = { class: "mb-1" }
const _hoisted_57 = /*#__PURE__*/_createVNode("strong", null, "Brugere:", -1)
const _hoisted_58 = { class: "mb-0" }
const _hoisted_59 = { class: "text-muted" }
const _hoisted_60 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_61 = /*#__PURE__*/_createTextVNode(" Se detaljer ")
const _hoisted_62 = {
  key: 1,
  class: "text-muted text-center py-3"
}
const _hoisted_63 = { class: "col-md-6" }
const _hoisted_64 = { class: "card" }
const _hoisted_65 = { class: "card-header d-flex align-items-center" }
const _hoisted_66 = /*#__PURE__*/_createVNode("h6", { class: "mb-0" }, "Seneste udførelse", -1)
const _hoisted_67 = { class: "card-body" }
const _hoisted_68 = {
  key: 0,
  class: "mb-0"
}
const _hoisted_69 = { class: "mb-2" }
const _hoisted_70 = { class: "mb-1" }
const _hoisted_71 = /*#__PURE__*/_createVNode("strong", null, "Tildelinger:", -1)
const _hoisted_72 = { class: "mb-1" }
const _hoisted_73 = /*#__PURE__*/_createVNode("strong", null, "Brugere:", -1)
const _hoisted_74 = { class: "mb-0" }
const _hoisted_75 = { class: "text-muted" }
const _hoisted_76 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_77 = /*#__PURE__*/_createTextVNode(" Se detaljer ")
const _hoisted_78 = {
  key: 1,
  class: "text-muted text-center py-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppHeader = _resolveComponent("AppHeader")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_VDButton = _resolveComponent("VDButton")!
  const _component_page = _resolveComponent("page")!
  const _component_BatchRoleAssignmentDetail = _resolveComponent("BatchRoleAssignmentDetail")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_page, {
      isLoading: _ctx.loading,
      error: _ctx.error || undefined
    }, {
      default: _withCtx(() => [
        _createVNode(_component_AppHeader, {
          canSearch: false,
          actionButtonTitle: undefined,
          title: "Batch rolletildeling"
        }, {
          subtitle: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }),
        _createVNode("div", _hoisted_2, [
          _createVNode("h4", _hoisted_3, [
            _createVNode(_component_font_awesome_icon, {
              icon: ['fas', 'plus'],
              class: "me-2 text-primary"
            }),
            _hoisted_4
          ]),
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, [
                _hoisted_8,
                _createVNode("input", {
                  type: "file",
                  class: "form-control",
                  id: "csvFile",
                  accept: ".csv",
                  ref: "fileInput",
                  onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onFileSelected && _ctx.onFileSelected(...args)))
                }, null, 544),
                _hoisted_9
              ]),
              (_ctx.selectedFile)
                ? (_openBlock(), _createBlock("div", _hoisted_10, [
                    _hoisted_11,
                    _createTextVNode(" " + _toDisplayString(_ctx.selectedFile.name) + " (" + _toDisplayString(_ctx.formatFileSize(_ctx.selectedFile.size)) + ") ", 1)
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_VDButton, {
                disabled: !_ctx.selectedFile || _ctx.uploadLoading,
                onClick: _ctx.uploadCsvFile,
                isLoading: _ctx.uploadLoading,
                icon: "plus",
                class: "btn btn-primary"
              }, {
                default: _withCtx(() => [
                  _hoisted_12
                ]),
                _: 1
              }, 8, ["disabled", "onClick", "isLoading"])
            ]),
            _hoisted_13
          ]),
          (_ctx.uploadResult)
            ? (_openBlock(), _createBlock("div", _hoisted_14, [
                (_ctx.uploadResult.success)
                  ? (_openBlock(), _createBlock("div", _hoisted_15, [
                      _createVNode("h6", null, [
                        _createVNode(_component_font_awesome_icon, {
                          icon: ['fas', 'check'],
                          class: "me-2"
                        }),
                        _hoisted_16
                      ]),
                      _createVNode("p", _hoisted_17, _toDisplayString(_ctx.uploadResult.validRoleAssignmentItems?.length || 0) + " rolletildeling(er) blev uploadet ", 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.uploadResult.errors && _ctx.uploadResult.errors.length > 0)
                  ? (_openBlock(), _createBlock("div", _hoisted_18, [
                      _createVNode("h6", null, [
                        _createVNode(_component_font_awesome_icon, {
                          icon: ['fas', 'minus'],
                          class: "me-2"
                        }),
                        _hoisted_19
                      ]),
                      _createVNode("ul", _hoisted_20, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.uploadResult.errors, (error, index) => {
                          return (_openBlock(), _createBlock("li", { key: index }, _toDisplayString(error), 1))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _hoisted_21,
          _hoisted_22,
          (_ctx.batchRoleAssignments && _ctx.batchRoleAssignments.length > 0)
            ? (_openBlock(), _createBlock("div", _hoisted_23, [
                _createVNode("h4", _hoisted_24, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: ['fas', 'user'],
                    class: "me-2 text-primary"
                  }),
                  _hoisted_25
                ]),
                _createVNode("div", _hoisted_26, [
                  _createVNode("div", _hoisted_27, [
                    (_ctx.isProcessingRunning)
                      ? (_openBlock(), _createBlock("div", _hoisted_28, [
                          _createVNode(_component_font_awesome_icon, {
                            icon: ['fas', 'spinner'],
                            class: "me-2",
                            spin: ""
                          }),
                          _hoisted_29
                        ]))
                      : (_openBlock(), _createBlock("div", _hoisted_30, [
                          _createVNode(_component_VDButton, {
                            disabled: _ctx.processingLoading || !_ctx.uploadResult?.success,
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.doBatchRoleAssignments(true))),
                            isLoading: _ctx.processingLoading && _ctx.isSimulation,
                            icon: "eye",
                            class: "btn btn-outline-primary"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_31
                            ]),
                            _: 1
                          }, 8, ["disabled", "isLoading"]),
                          _createVNode(_component_VDButton, {
                            disabled: _ctx.processingLoading || !_ctx.uploadResult?.success,
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.doBatchRoleAssignments(false))),
                            isLoading: _ctx.processingLoading && !_ctx.isSimulation,
                            icon: "check",
                            class: "btn btn-primary"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_32
                            ]),
                            _: 1
                          }, 8, ["disabled", "isLoading"])
                        ])),
                    (_ctx.processingResult)
                      ? (_openBlock(), _createBlock("div", _hoisted_33, [
                          (_ctx.processingResult.success)
                            ? (_openBlock(), _createBlock("div", _hoisted_34, [
                                _createVNode("h6", null, [
                                  _createVNode(_component_font_awesome_icon, {
                                    icon: ['fas', 'check'],
                                    class: "me-2"
                                  }),
                                  _createTextVNode(" " + _toDisplayString(_ctx.processingResult.isSimulation ? "Simulation" : "Udførelse") + " Succesfuld ", 1)
                                ]),
                                _createVNode("p", _hoisted_35, [
                                  _hoisted_36,
                                  _createTextVNode(" " + _toDisplayString(_ctx.processingResult.totalAssignments || 0), 1),
                                  _hoisted_37,
                                  _hoisted_38,
                                  _createTextVNode(" " + _toDisplayString(_ctx.processingResult.totalUsersAssignment || 0), 1)
                                ]),
                                (_ctx.processingResult.processedAt)
                                  ? (_openBlock(), _createBlock("div", _hoisted_39, [
                                      _createVNode("small", _hoisted_40, " Behandlet: " + _toDisplayString(_ctx.displayDanishTimestamp(_ctx.processingResult.processedAt)), 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          (
                  _ctx.processingResult.errors && _ctx.processingResult.errors.length > 0
                )
                            ? (_openBlock(), _createBlock("div", _hoisted_41, [
                                _createVNode("h6", null, [
                                  _createVNode(_component_font_awesome_icon, {
                                    icon: ['fas', 'minus'],
                                    class: "me-2"
                                  }),
                                  _createTextVNode(" " + _toDisplayString(_ctx.processingResult.isSimulation ? "Simulation" : "Udførelse") + " Fejl ", 1)
                                ]),
                                _createVNode("ul", _hoisted_42, [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.processingResult.errors, (error, index) => {
                                    return (_openBlock(), _createBlock("li", { key: index }, _toDisplayString(error), 1))
                                  }), 128))
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_43, [
          _createVNode("h4", _hoisted_44, [
            _createVNode(_component_font_awesome_icon, {
              icon: ['fas', 'eye'],
              class: "me-2 text-primary"
            }),
            _hoisted_45
          ]),
          _createVNode("div", _hoisted_46, [
            _createVNode("div", _hoisted_47, [
              _createVNode("div", _hoisted_48, [
                _createVNode("div", _hoisted_49, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: ['fas', 'eye'],
                    class: "me-2 text-info"
                  }),
                  _hoisted_50
                ]),
                _createVNode("div", _hoisted_51, [
                  (_ctx.parseHistoricalResult(_ctx.lastSimulation))
                    ? (_openBlock(), _createBlock("div", _hoisted_52, [
                        _createVNode("div", null, [
                          _createVNode("div", null, [
                            _createVNode("div", _hoisted_53, [
                              _createVNode("span", {
                                class: `badge ${
                          _ctx.parseHistoricalResult(_ctx.lastSimulation)?.Success
                            ? 'bg-success'
                            : 'bg-danger'
                        }`
                              }, _toDisplayString(_ctx.parseHistoricalResult(_ctx.lastSimulation)?.Success
                            ? "Succesfuld"
                            : "Fejl"), 3)
                            ]),
                            _createVNode("p", _hoisted_54, [
                              _hoisted_55,
                              _createTextVNode(" " + _toDisplayString(_ctx.parseHistoricalResult(_ctx.lastSimulation)
                          ?.TotalAssignments || 0), 1)
                            ]),
                            _createVNode("p", _hoisted_56, [
                              _hoisted_57,
                              _createTextVNode(" " + _toDisplayString(_ctx.parseHistoricalResult(_ctx.lastSimulation)
                          ?.TotalUsersAssignment || 0), 1)
                            ]),
                            _createVNode("p", _hoisted_58, [
                              _createVNode("small", _hoisted_59, _toDisplayString(_ctx.displayDanishTimestamp(
                            _ctx.parseHistoricalResult(_ctx.lastSimulation)
                              ?.ProcessedAt || ""
                          )), 1)
                            ])
                          ]),
                          _hoisted_60,
                          _createVNode(_component_VDButton, {
                            onClick: _ctx.showSimulationDetails,
                            icon: "eye",
                            class: "btn btn-sm btn-outline-primary"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_61
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ])
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_62, " Ingen simulation kørt endnu "))
                ])
              ])
            ]),
            _createVNode("div", _hoisted_63, [
              _createVNode("div", _hoisted_64, [
                _createVNode("div", _hoisted_65, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: ['fas', 'check'],
                    class: "me-2 text-success"
                  }),
                  _hoisted_66
                ]),
                _createVNode("div", _hoisted_67, [
                  (_ctx.parseHistoricalResult(_ctx.lastExecution))
                    ? (_openBlock(), _createBlock("div", _hoisted_68, [
                        _createVNode("div", null, [
                          _createVNode("div", null, [
                            _createVNode("div", _hoisted_69, [
                              _createVNode("span", {
                                class: `badge ${
                          _ctx.parseHistoricalResult(_ctx.lastExecution)?.Success
                            ? 'bg-success'
                            : 'bg-danger'
                        }`
                              }, _toDisplayString(_ctx.parseHistoricalResult(_ctx.lastExecution)?.Success
                            ? "Succesfuld"
                            : "Fejl"), 3)
                            ]),
                            _createVNode("p", _hoisted_70, [
                              _hoisted_71,
                              _createTextVNode(" " + _toDisplayString(_ctx.parseHistoricalResult(_ctx.lastExecution)
                          ?.TotalAssignments || 0), 1)
                            ]),
                            _createVNode("p", _hoisted_72, [
                              _hoisted_73,
                              _createTextVNode(" " + _toDisplayString(_ctx.parseHistoricalResult(_ctx.lastExecution)
                          ?.TotalUsersAssignment || 0), 1)
                            ]),
                            _createVNode("p", _hoisted_74, [
                              _createVNode("small", _hoisted_75, _toDisplayString(_ctx.displayDanishTimestamp(
                            _ctx.parseHistoricalResult(_ctx.lastExecution)?.ProcessedAt ||
                              ""
                          )), 1)
                            ])
                          ]),
                          _hoisted_76,
                          _createVNode(_component_VDButton, {
                            onClick: _ctx.showExecutionDetails,
                            icon: "eye",
                            class: "btn btn-sm btn-outline-primary"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_77
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ])
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_78, " Ingen udførelse kørt endnu "))
                ])
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["isLoading", "error"]),
    (_ctx.sidebar.selectedResult.value)
      ? (_openBlock(), _createBlock(_component_BatchRoleAssignmentDetail, {
          key: 0,
          result: _ctx.sidebar.selectedResult.value,
          onHide: _ctx.sidebar.hideSidebar
        }, null, 8, ["result", "onHide"]))
      : _createCommentVNode("", true)
  ], 64))
}